export default __webpack_public_path__ + "static/iot1-d300ebd8a503d17065ecd45f8a899b48.png";